import type { TimelineEvent } from "@productlane/api/src/browser"

import type { ActivatePlacement } from "@/screens/app/threads/components/center-content/timeline-events/shadow-reply-event"
import type { ThreadContextState } from "@/screens/app/threads/thread-context"
import { ShadowReplyEvent } from "@/screens/app/threads/components/center-content/timeline-events/shadow-reply-event"
import { ThreadContextProvider } from "@/screens/app/threads/thread-context"

const VARIANTS: {
	placement: ActivatePlacement
	title: string
	note: string
}[] = [
	{
		placement: "row-end",
		title: "A · End of the action row",
		note: "Small ghost button, pushed to the right edge, apart from Send, Regenerate and Decline.",
	},
	{
		placement: "header",
		title: "B · In the bubble header",
		note: "Next to the team-only label, top right, far from the review actions.",
	},
	{
		placement: "below",
		title: "C · Under the bubble",
		note: "A quiet line outside the card that reads as a setting, not part of this reply.",
	},
]

const threadContext = {
	thread: {
		id: "design_thread",
		workspaceId: "design_ws",
		company: null,
		contact: null,
	},
} as unknown as ThreadContextState

const previewEvent = {
	type: "activity",
	threadActivity: {
		id: "design_preview",
		eventType: "ai_shadow_reply",
		payload: {
			html: "<p>Hallo Lena,</p><p>danke für deine Nachricht. Laut Preisseite kostet der Starter-Plan $29 pro Nutzer und Monat. Den Preis bei monatlicher Abrechnung siehst du, wenn du dort auf Monthly umschaltest: <a href='https://productlane.com/pricing'>productlane.com/pricing</a></p>",
			channel: "email",
			status: "pending",
		},
		createdAt: new Date(2026, 9, 13, 17, 7).getTime(),
	},
} as unknown as TimelineEvent

export function ShadowActivateButtonPage() {
	return (
		<div className="h-full overflow-y-auto bg-[var(--bg-primary)] pb-16">
			<div className="mx-auto flex max-w-3xl flex-col gap-12 px-6 py-10">
				<div>
					<h1 className="text-lg font-medium text-primary">
						Turn on auto-reply: where it sits
					</h1>
					<p className="mt-1 text-sm text-secondary">
						The real preview card, three placements. Buttons are live, so
						clicking opens the real dialogs.
					</p>
				</div>
				<ThreadContextProvider value={threadContext}>
					{VARIANTS.map((v) => (
						<section key={v.placement} className="flex flex-col gap-3">
							<div>
								<h2 className="text-sm font-medium text-primary">{v.title}</h2>
								<p className="text-xs text-tertiary">{v.note}</p>
							</div>
							<div className="px-2">
								<ShadowReplyEvent
									event={previewEvent}
									activatePlacement={v.placement}
								/>
							</div>
						</section>
					))}
				</ThreadContextProvider>
			</div>
		</div>
	)
}
